import http from "./configServices/httpService";
import { base_url } from "./configServices/config";

// Start Auth
export const signInService = (data) => {
  return http.post(`${base_url}/console_login/`, data);
};
// End Auth

// Start OTP
export const sendOTPService = (data) => {
  return http.post(`${base_url}/auth/mobile/`, data);
};

export const verifyOTPService = (data) => {
  return http.post(`${base_url}/callback/auth/`, data);
};
// End OTP

// Start Config
export const getConfigsService = (params) => {
  return http.get(`${base_url}/api/config/`, { params });
};
export const editConfigService = (data) => {
  return http.put(`${base_url}/api/config/${data.key}/`, data);
};
// End Config

// Start Profile
export const editInfoService = (data, token) => {
  return http.post(
    `${base_url}/user_profile_update/`,
    data,
    token
      ? {
          headers: {
            Authorization: `token ${token}`,
          },
        }
      : {}
  );
};

export const sendUserProfilePhotoService = (data) => {
  return http.post(`${base_url}/upload_image/`, data);
};

export const getUserProfilePhotoService = (data) => {
  return http.post(`${base_url}/download_image/`, data);
};

export const getUserProfileService = () => {
  return http.get(`${base_url}/user_profile_read/`);
};
// End Profile

// Start Survey
export const getSurveyItemsService = () => {
  return http.post(`${base_url}/survey_item_list/`);
};

export const createSurveyItemService = (data) => {
  return http.post(`${base_url}/survey_item_create/`, data);
};

export const deleteSurveyItemService = (data) => {
  return http.delete(`${base_url}/survey_item_delete/`, {
    data,
  });
};

export const sendSurveyService = (data) => {
  return http.post(`${base_url}/user_update/`, data);
};
// End Survey

// Start Category
export const getCategoryItemsService = (data) => {
  return http.post(`${base_url}/service_category_list/`, data);
};

export const getCategoryService = (data) => {
  return http.post(`${base_url}/service_category_read/`, data);
};

export const createCategoryItemService = (data) => {
  return http.post(`${base_url}/service_category_create_update/`, data);
};

export const editCategoryItemService = (data) => {
  return http.post(`${base_url}/service_category_create_update/`, data);
};

export const deleteCategoryItemService = (data) => {
  return http.delete(`${base_url}/service_category_delete/`, {
    data,
  });
};
// End Category

// Start Canceling Reason
export const getCancelingReasonService = () => {
  return http.get(`${base_url}/api/canceling_reason/`);
};

export const createCancelingReasonService = (data) => {
  return http.post(`${base_url}/api/canceling_reason/`, data);
};

export const deleteCancelingReasonService = (id) => {
  return http.delete(`${base_url}/api/canceling_reason/${id}`);
};
// End Canceling Reason

// Start Failing Reason
export const getFailingReasonService = (params) => {
  return http.get(`${base_url}/api/failing_reason/`, { params });
};

export const createFailingReasonService = (data) => {
  return http.post(`${base_url}/api/failing_reason/`, data);
};

export const deleteFailingReasonService = (id) => {
  return http.delete(`${base_url}/api/failing_reason/${id}`);
};
// End Failing Reason

// Start Return User Status
export const getReturnUserStatusService = () => {
  return http.get(`${base_url}/api/return_user_status/`);
};

export const createReturnUserStatusService = (data) => {
  return http.post(`${base_url}/api/return_user_status/`, data);
};

export const deleteReturnUserStatusService = (id) => {
  return http.delete(`${base_url}/api/return_user_status/${id}`);
};
// End Return User Status

// Start Employer
export const createUserEmployerService = (data) => {
  return http.post(`${base_url}/admin_user_employer_create/`, data);
};

export const deleteUserEmployerService = (data) => {
  return http.post(`${base_url}/admin_user_employer_delete/`, data);
};

export const getEmployersService = () => {
  return http.post(`${base_url}/employer_list/`);
};

export const createEmployerService = (data) => {
  return http.post(`${base_url}/employer_create_update/`, data);
};

export const editEmployerService = (data) => {
  return http.post(`${base_url}/employer_create_update/`, data);
};

export const deleteEmployerService = (data) => {
  return http.delete(`${base_url}/employer_delete/`, {
    data,
  });
};
// End Employer

// Start Group Charge
export const createGroupChargeService = (data) => {
  return http.post(`${base_url}/api/group_charge/`, data);
};
// End Group Charge

// Start Personnel
export const getPersonnelsEmployerService = (data) => {
  return http.post(`${base_url}/employee_list/`, data);
};

export const getPersonnelsService = (params) => {
  return http.get(`${base_url}/api/personnels/`, {
    params,
  });
};

export const getPersonnelService = (data) => {
  return http.get(`${base_url}/api/personnels/${data.id}/`);
};

export const createPersonnelService = (data) => {
  return http.post(`${base_url}/api/personnels/`, data);
};

export const editPersonnelsService = (data) => {
  return http.put(`${base_url}/api/personnels/${data.id}/`, data);
};

export const deletePersonnelService = (id) => {
  return http.delete(`${base_url}/api/personnels/${id}/`);
};

export const getEnteredEmployeeCodeService = (params) => {
  return http.get(`${base_url}/api/entered_employee_code/`, { params });
};
// End Personnel

// Start Service
export const getServicesService = (data) => {
  return http.post(`${base_url}/get_all_services_admin/`, data);
};

export const createServiceService = (data) => {
  return http.post(`${base_url}/moderator_create_update/`, data);
};

export const editServiceService = (data) => {
  return http.post(`${base_url}/moderator_create_update/`, data);
};

export const getServiceService = (data) => {
  return http.post(`${base_url}/moderator_read/`, data);
};

export const deleteServiceService = (data) => {
  return http.delete(`${base_url}/moderator_delete/`, {
    data,
  });
};
// End Service

// Start User
export const getUsersService = (params) => {
  return http.get(`${base_url}/api/users/`, { params });
};

export const getUserService = (id) => {
  return http.get(`${base_url}/api/users/${id}/`);
};

export const createUserService = (data) => {
  return http.post(`${base_url}/api/users/`, data);
};

export const editUserService = (data) => {
  return http.put(`${base_url}/api/users/${data.pk}/`, data);
};

export const deleteUserService = (id) => {
  return http.delete(`${base_url}/api/users/${id}/`);
};

export const getUserAddressesService = (data) => {
  return http.post(`${base_url}/admin_address_list/`, data);
};

export const createUserAddressService = (data) => {
  return http.post(`${base_url}/admin_address_create_update/`, data);
};

export const editUserAddressService = (data) => {
  return http.post(`${base_url}/admin_address_create_update/`, data);
};
// End User

// Start Order
export const getOrdersService = (data) => {
  return http.post(`${base_url}/admin_list/`, data, {
    params: data,
  });
};

export const getOrderService = (data) => {
  return http.post(`${base_url}/admin_read/`, data);
};

export const createOrderService = (data) => {
  return http.post(`${base_url}/admin_create_update/`, data);
};

export const editOrderService = (data) => {
  return http.post(`${base_url}/admin_create_update/`, data);
};

export const deleteOrderService = (data) => {
  return http.delete(`${base_url}/admin_delete/`, {
    data,
  });
};

export const sendSMSToPersonnelService = (data) => {
  return http.post(`${base_url}/send_sms_to_personnel/`, data);
};

export const sendEducationalSMSService = (data) => {
  return http.post(`${base_url}/send_educational_sms/`, data);
};

export const sendOrderToPersonnelSMSService = (data) => {
  return http.post(`${base_url}/send_order_to_personnel/`, data);
};

export const editAddressService = (data) => {
  return http.post(`${base_url}/admin_address_create_update/`, data);
};

export const editDiscountService = (data) => {
  return http.post(`${base_url}/admin_discount_create_update/`, data);
};

export const checkDiscountService = (data) => {
  return http.post(`${base_url}/use_discount_check/`, JSON.stringify(data));
};
// End Order

// Start Log
export const runShellStatisticsService = (data) => {
  return http.post(`${base_url}/run_shell_statistics/`, data);
};

export const getLogsService = (params) => {
  return http.get(`${base_url}/api/admin_logs/`, { params });
};

export const createLogService = (data) => {
  return http.post(`${base_url}/api/admin_logs/`, data);
};
// End Log

// Start Province
export const getProvincesService = (data) => {
  return http.post(`${base_url}/province_list/`, data);
};

export const createProvinceService = (data) => {
  return http.post(`${base_url}/province_create_update/`, data);
};

export const editProvinceService = (data) => {
  return http.post(`${base_url}/province_create_update/`, data);
};

export const deleteProvinceService = (data) => {
  return http.delete(`${base_url}/province_delete/`, {
    data,
  });
};
// End Province

// Start City
export const getCitiesService = (data) => {
  return http.post(`${base_url}/city_list/`, data);
};

export const createCityService = (data) => {
  return http.post(`${base_url}/city_create_update/`, data);
};

export const editCityService = (data) => {
  return http.post(`${base_url}/city_create_update/`, data);
};

export const deleteCityService = (data) => {
  return http.delete(`${base_url}/city_delete/`, {
    data,
  });
};
// End City

// Start Use Discount
export const getUseDiscountsService = (data) => {
  return http.post(`${base_url}/used_discounts/`, data);
};
// End Discount

// Start Invoice
export const getInvoicesService = (params) => {
  return http.get(`${base_url}/api/invoices/`, { params });
};
export const getInvoiceService = (invoiceId) => {
  return http.get(`${base_url}/api/invoices/${invoiceId}/`);
};
export const createInvoiceService = (data) => {
  return http.post(`${base_url}/api/invoices/`, data);
};
export const deleteInvoiceService = (invoiceId) => {
  return http.delete(`${base_url}/api/invoices/${invoiceId}/`);
};
export const editInvoiceService = (data) => {
  return http.put(`${base_url}/api/invoices/${data.id}/`, data);
};
export const sendInvoiceToClientService = (id) => {
  return http.get(`${base_url}/send_invoice_to_client/${id}/`);
};
// End Invoice

// Start Discount Coupon
export const getDiscountCouponItemsService = (data) => {
  return http.post(`${base_url}/discountcoupon_list/`, data);
};

export const getDiscountCouponService = (data) => {
  return http.post(`${base_url}/discountcoupon_read/`, data);
};

export const createDiscountCouponItemService = (data) => {
  return http.post(`${base_url}/discountcoupon_create_update/`, data);
};

export const editDiscountCouponItemService = (data) => {
  return http.post(`${base_url}/discountcoupon_create_update/`, data);
};

export const deleteDiscountCouponItemService = (data) => {
  return http.delete(`${base_url}/discountcoupon_delete/`, {
    data,
  });
};
// End Discount Coupon

// Start Analysis
export const kpiAnalysisService = (data) => {
  return http.post(`${base_url}/kpi_analysis/`, data);
};
// End Analysis

// Start Wallet
export const getWalletsService = (params) => {
  return http.get(`${base_url}/api/wallet/`, { params });
};

export const getWalletService = (userId) => {
  return http.get(`${base_url}/api/wallet/${userId}/`);
};

export const createWalletService = (data) => {
  return http.post(`${base_url}/api/wallet/`, data);
};

export const editWalletService = (data) => {
  return http.put(`${base_url}/api/wallet/${data.user}/`, data);
};

export const deleteWalletService = (id) => {
  return http.delete(`${base_url}/api/wallet/${id}/`);
};
// End Wallet

// Start Payment Transaction
export const getPaymentTransactionsService = (params) => {
  return http.get(`${base_url}/api/paymenttransactions/`, { params });
};

export const getPaymentTransactionService = (id) => {
  return http.get(`${base_url}/api/paymenttransactions/${id}/`);
};

export const createPaymentTransactionService = (data) => {
  return http.post(`${base_url}/api/paymenttransactions/`, data);
};

export const editPaymentTransactionService = (data) => {
  return http.put(`${base_url}/api/paymenttransactions/${data.id}/`, data);
};

export const deletePaymentTransactionService = (id) => {
  return http.delete(`${base_url}/api/paymenttransactions/${id}/`);
};
// End Payment Transaction

// Start Employee
export const getEmployeesService = (params) => {
  return http.get(`${base_url}/api/employees/`, { params });
};
export const getEmployeeService = (id) => {
  return http.get(`${base_url}/api/employees/${id}/`);
};
export const createEmployeeService = (data) => {
  return http.post(`${base_url}/api/employees/`, data);
};
export const editEmployeeService = (data) => {
  return http.put(`${base_url}/api/employees/${data.id}/`, data);
};
export const deleteEmployeeService = (id) => {
  return http.delete(`${base_url}/api/employees/${id}/`);
};
// End Employee

// Start User Satisfaction Item
export const getUserSatisfactionItemsService = (params) => {
  return http.get(`${base_url}/api/usersatisfactionitems/`, { params });
};
export const getUserSatisfactionItemService = (id) => {
  return http.get(`${base_url}/api/usersatisfactionitems/${id}/`);
};
export const createUserSatisfactionItemService = (data) => {
  return http.post(`${base_url}/api/usersatisfactionitems/`, data);
};
export const editUserSatisfactionItemService = (data) => {
  return http.put(`${base_url}/api/usersatisfactionitems/${data.id}/`, data);
};
export const deleteUserSatisfactionItemService = (id) => {
  return http.delete(`${base_url}/api/usersatisfactionitems/${id}/`);
};
// End User Satisfaction Item

// Start Rejection Reason Item
export const getRejectionReasonItemsService = (params) => {
  return http.get(`${base_url}/api/rejection-reasons/`, { params });
};
export const getRejectionReasonItemService = (id) => {
  return http.get(`${base_url}/api/rejection-reasons/${id}/`);
};
export const createRejectionReasonItemService = (data) => {
  return http.post(`${base_url}/api/rejection-reasons/`, data);
};
export const editRejectionReasonItemService = (data) => {
  return http.put(`${base_url}/api/rejection-reasons/${data.id}/`, data);
};
export const deleteRejectionReasonItemService = (id) => {
  return http.delete(`${base_url}/api/rejection-reasons/${id}/`);
};
// End Rejection Reason Item

// Start Recruitment Item
export const getRecruitmentItemsService = (params) => {
  return http.get(`${base_url}/api/recruitments/`, { params });
};
export const getRecruitmentItemService = (id) => {
  return http.get(`${base_url}/api/recruitments/${id}/`);
};
export const createRecruitmentItemService = (data) => {
  return http.post(`${base_url}/api/recruitments/`, data);
};
export const editRecruitmentItemService = (data) => {
  return http.put(`${base_url}/api/recruitments/${data.id}/`, data);
};
export const deleteRecruitmentItemService = (id) => {
  return http.delete(`${base_url}/api/recruitments/${id}/`);
};
// End Recruitment Item

// Start Failure Request Comment Item
export const getFailureRequestCommentItemsService = (params) => {
  return http.get(`${base_url}/api/failurerequestcomments/`, { params });
};
export const getFailureRequestCommentItemService = (id) => {
  return http.get(`${base_url}/api/failurerequestcomments/${id}/`);
};
export const createFailureRequestCommentItemService = (data) => {
  return http.post(`${base_url}/api/failurerequestcomments/`, data);
};
export const editFailureRequestCommentItemService = (data) => {
  return http.put(`${base_url}/api/failurerequestcomments/${data.id}/`, data);
};
export const deleteFailureRequestCommentItemService = (id) => {
  return http.delete(`${base_url}/api/failurerequestcomments/${id}/`);
};
// End Failure Request Comment Item

// Start Failure Request Item
export const getFailureRequestItemsService = (params) => {
  return http.get(`${base_url}/api/failurerequestitems/`, { params });
};
export const getFailureRequestItemService = (id) => {
  return http.get(`${base_url}/api/failurerequestitems/${id}/`);
};
export const createFailureRequestItemService = (data) => {
  return http.post(`${base_url}/api/failurerequestitems/`, data);
};
export const editFailureRequestItemService = (data) => {
  return http.put(`${base_url}/api/failurerequestitems/${data.id}/`, data);
};
export const deleteFailureRequestItemService = (id) => {
  return http.delete(`${base_url}/api/failurerequestitems/${id}/`);
};
// End Failure Request Item

// Start Failure Request
export const getFailureRequestsService = (params) => {
  return http.get(`${base_url}/api/failurerequests/`, { params });
};
export const getFailureRequestService = (id) => {
  return http.get(`${base_url}/api/failurerequests/${id}/`);
};
export const createFailureRequestService = (data) => {
  return http.post(`${base_url}/api/failurerequests/`, data);
};
export const editFailureRequestService = (data) => {
  return http.put(`${base_url}/api/failurerequests/${data.id}/`, data);
};
export const deleteFailureRequestService = (id) => {
  return http.delete(`${base_url}/api/failurerequests/${id}/`);
};
// End Failure Request

// Start Violation Solved Item
export const getViolationSolvedItemsService = (params) => {
  return http.get(`${base_url}/api/violationsolveditems/`, { params });
};
export const getViolationSolvedItemService = (id) => {
  return http.get(`${base_url}/api/violationsolveditems/${id}/`);
};
export const createViolationSolvedItemService = (data) => {
  return http.post(`${base_url}/api/violationsolveditems/`, data);
};
export const editViolationSolvedItemService = (data) => {
  return http.put(`${base_url}/api/violationsolveditems/${data.id}/`, data);
};
export const deleteViolationSolvedItemService = (id) => {
  return http.delete(`${base_url}/api/violationsolveditems/${id}/`);
};
// End Violation Solved Item

// Start Violation Type Item
export const getViolationTypeItemsService = (params) => {
  return http.get(`${base_url}/api/violationtypeitems/`, { params });
};
export const getViolationTypeItemService = (id) => {
  return http.get(`${base_url}/api/violationtypeitems/${id}/`);
};
export const createViolationTypeItemService = (data) => {
  return http.post(`${base_url}/api/violationtypeitems/`, data);
};
export const editViolationTypeItemService = (data) => {
  return http.put(`${base_url}/api/violationtypeitems/${data.id}/`, data);
};
export const deleteViolationTypeItemService = (id) => {
  return http.delete(`${base_url}/api/violationtypeitems/${id}/`);
};
// End Violation Type Item

// Start Violation Comment
export const getViolationCommentItemsService = (params) => {
  return http.get(`${base_url}/api/violationcomments/`, { params });
};
export const getViolationCommentItemService = (id) => {
  return http.get(`${base_url}/api/violationcomments/${id}/`);
};
export const createViolationCommentItemService = (data) => {
  return http.post(`${base_url}/api/violationcomments/`, data);
};
export const editViolationCommentItemService = (data) => {
  return http.put(`${base_url}/api/violationcomments/${data.id}/`, data);
};
export const deleteViolationCommentItemService = (id) => {
  return http.delete(`${base_url}/api/violationcomments/${id}/`);
};
// End Violation Comment

// Start Violation Result Item
export const getViolationResultItemsService = (params) => {
  return http.get(`${base_url}/api/violationresultitems/`, { params });
};
export const getViolationResultItemService = (id) => {
  return http.get(`${base_url}/api/violationresultitems/${id}/`);
};
export const createViolationResultItemService = (data) => {
  return http.post(`${base_url}/api/violationresultitems/`, data);
};
export const editViolationResultItemService = (data) => {
  return http.put(`${base_url}/api/violationresultitems/${data.id}/`, data);
};
export const deleteViolationResultItemService = (id) => {
  return http.delete(`${base_url}/api/violationresultitems/${id}/`);
};
// End Violation Result Item

// Start Violations
export const getViolationsService = (params) => {
  return http.get(`${base_url}/api/violations/`, { params });
};
export const getViolationService = (id) => {
  return http.get(`${base_url}/api/violations/${id}/`);
};
export const createViolationService = (data) => {
  return http.post(`${base_url}/api/violations/`, data);
};
export const editViolationService = (data) => {
  return http.put(`${base_url}/api/violations/${data.id}/`, data);
};
export const deleteViolationService = (id) => {
  return http.delete(`${base_url}/api/violations/${id}/`);
};
// End Violations

// Start Comment
export const addOrderCommentService = (data) => {
  return http.post(`${base_url}/admin_add_comment/`, data);
};
export const addPersonnelCommentService = (data) => {
  return http.post(`${base_url}/personnel_add_comment/`, data);
};
// End Comment

// Start Critics Suggestions
export const getCriticsSuggestionsService = (params) => {
  return http.get(`${base_url}/api/admincriticssuggestions/`, { params });
};
export const editCriticsSuggestionService = (data) => {
  return http.put(`${base_url}/api/admincriticssuggestions/${data.id}/`, data);
};
// End Critics Suggestions

// Start Upload Document
export const uploadPersonnelDocumentService = (data) => {
  return http.post(`${base_url}/api/personnel/upload-document/`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
export const deletePersonnelDocumentService = (id) => {
  return http.delete(`${base_url}/api/personnel/document/${id}/delete/`);
};
export const getPersonnelDocumentService = (id) => {
  return http.get(`${base_url}/api/personnel/document/${id}/download/`, {
    responseType: "blob",
  });
};
// End Upload Document

// Start SMS Template Item
export const getSMSTemplateItemsService = (params) => {
  return http.get(`${base_url}/api/sms_messages/`, { params });
};
export const getSMSTemplateItemService = (id) => {
  return http.get(`${base_url}/api/sms_messages/${id}/`);
};
export const createSMSTemplateItemService = (data) => {
  return http.post(`${base_url}/api/sms_messages/`, data);
};
export const editSMSTemplateItemService = (data) => {
  return http.put(`${base_url}/api/sms_messages/${data.id}/`, data);
};
export const deleteSMSTemplateItemService = (id) => {
  return http.delete(`${base_url}/api/sms_messages/${id}/`);
};
// End SMS Template Item

// Start Roulette Item
export const getRouletteItemsService = (params) => {
  return http.get(`${base_url}/api/roulette/items/`, { params });
};
export const getRouletteItemService = (id) => {
  return http.get(`${base_url}/api/roulette/items/${id}/`);
};
export const createRouletteItemService = (data) => {
  return http.post(`${base_url}/api/roulette/items/`, data);
};
export const editRouletteItemService = (data) => {
  return http.put(`${base_url}/api/roulette/items/${data.id}/`, data);
};
export const deleteRouletteItemService = (id) => {
  return http.delete(`${base_url}/api/roulette/items/${id}/`);
};
// End Roulette Item

// Start Roulette Result
export const getRouletteResultItemsService = (params) => {
  return http.get(`${base_url}/api/roulette/results/`, { params });
};
// End Roulette Result

// Start Admin
export const getAdminsService = (params) => {
  return http.get(`${base_url}/api/admins/`, { params });
};

export const getAdminService = (id) => {
  return http.get(`${base_url}/api/admins/${id}/`);
};

export const createAdminService = (data) => {
  return http.post(`${base_url}/api/admins/`, data);
};

export const editAdminService = (data) => {
  return http.put(`${base_url}/api/admins/${data.pk}/`, data);
};

export const deleteAdminService = (id) => {
  return http.delete(`${base_url}/api/admins/${id}/`);
};

export const revokeTokenAdminService = (id) => {
  return http.post(`${base_url}/api/admins/${id}/revoke-token/`);
};
// End Admin

// Start Admin
export const compareOrderAdminService = (data) => {
  return http.post(`${base_url}/compare_orders/`, data);
};
// End Admin

// Start Back Up
export const getBackUpsService = () => {
  return http.get(`${base_url}/api/backups/`);
};
export const getBackUpService = (id) => {
  return http.get(`${base_url}/api/backups/${id}/`);
};
// End Back Up
